module.exports = __webpack_public_path__ + "img/es-pc-step-2.a07a2ea0.png";